import React from 'react';

/** Boostrap Components */  
import { Card,Container,Row,Col,Form,Button } from 'react-bootstrap';  

/** Select component */
import Select from 'react-select'

/** Custom Components */
import NavbarComponent from '../navbar';
import FooterComponent from '../footer';
import SideMenuComponent from './sidemenu';

import { AUTH_URL, FINYEAR_LIST_URL,UPLOAD_MENU_URL,MENU_HEADER_URL } from '../utils/constants';

class AddMenuComponent extends React.Component { 
	constructor(props) {
		super(props);
		this.state = {
			pdfFile: '',
			finYear: '',
			finyearList: [],
			title: '',
			descr: '',
			isLoaded: false,
			menuList: [],
			parentMenu: '',
			menu: '',
			disabled: false
		}
		this.onChangeFinyear = this.onChangeFinyear.bind(this);
		this.onChangeTitle = this.onChangeTitle.bind(this);
		this.onChangeDesc = this.onChangeDesc.bind(this);
	}

	componentDidMount() {
		fetch(AUTH_URL,{method:'POST',headers:{Authorization: 'Bearer '+sessionStorage.getItem('token')}})
			.then(res => res.json())
			.then(user => {
				fetch(FINYEAR_LIST_URL,{method : 'POST'})
					.then(res => res.json())
					.then(
						(result2) => {
							this.setState({
								isLoaded: true,
								finyearList: result2
							});
						},
						(error) => {
							this.setState({
								isLoaded: true,
								error
							});
						}
					)
				},
				(error)=>{
					alert('Session expired. Redirecting...');
					this.props.history("/login");
					return false;
				}
			)
			.catch(error => {
				alert('Unauthorized Login!!');
				this.props.history("/login");
				return false;
			})

	}

	onChangeFinyear = event => {
		this.setState({finYear: event.value,disabled: false});
			let requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ fin_year: event.value })
			};
			fetch(MENU_HEADER_URL,requestOptions)
				.then(res => res.json())
				.then(
					(result) => {
						this.setState({menuList: result.DATA});
						this.render();
					}
				)
	}
	onChangeParentMenu = event => {
		this.setState({parentMenu: event.value});
	}
	onChangeTitle = event => {
		this.setState({title: event.target.value});
	}
	onChangeDesc = event => {
		this.setState({descr: event.target.value});
	}
	onChangeMenu = event => {
		this.setState({menu: event.value,disabled: true});
		if(event.value === '')
			this.setState({menu: event.value,disabled: false});
	}
	
	onFileChange = event => {
		this.setState({ pdfFile: event.target.files[0] });
	};
	  
	onFileUpload = (event) => {
		event.preventDefault();
		const formData = new FormData();
		if(this.state.finYear === ''){
			alert('Select financial year!');
			return false;
		}
		if(this.state.title === '' && this.state.menu === ''){
			alert('Enter title of menu or select one of existing menu!');
			return false;
		}
		
		formData.append("menu",this.state.menu);
		formData.append("title",this.state.title);
		formData.append("descr",this.state.descr);
		formData.append("fin_year",this.state.finYear);
		formData.append("username",sessionStorage.getItem('user'));
		formData.append("parentMenu",this.state.parentMenu);

		if(this.state.pdfFile !== '' && this.state.pdfFile !== undefined){
			formData.append(
			"pdfFile",
			this.state.pdfFile,
			this.state.pdfFile.name
			);
		}
		else{
			if (window.confirm("You have not selected a file. Click Confirm to proceed or Cancel to go back!") !== true) {
				return false;
			} 
		}
		

		var url = UPLOAD_MENU_URL;

		fetch(url,{method:'POST',body:formData})
			.then(res => res.json())
			.then(
				(result) => {
					alert(result.MESSAGE);
					this.setState({pdfFile: '',menu: '',parent: ''})
					event.target.reset();
				},
				(error) => {
					alert("Error while uploading")
				}
			)

	};

	render() {
		const { finyearList, menuList, disabled } = this.state;
	
		var finyearOptions = [];
		finyearList.forEach(finyear=>{
			finyearOptions.push({value: finyear, label: finyear})
		});

		var menuListOptions = [];
		menuListOptions.push({value:'', label: '----- SELECT PARENT MENU ----'})
		menuList.forEach(menu=>{
			//if(menu.menu_type !== 'pdf')
				menuListOptions.push({value:menu.id, label: menu.name})
		});
		
		var existingMenuOption = [];
		existingMenuOption.push({value:'', label: '----- SELECT MENU ----'})
		menuList.forEach(menu=>{
			//if(menu.menu_type === 'pdf' || menu.menu_type === 'NC')
			existingMenuOption.push({value:menu.id, label: menu.name})
		});
		return (
			<div>
				<NavbarComponent/>
				<nav className="sticky"></nav>
				<div className="App-common main"> 
					<Container>
						<Row className='mt-3'>
							<Col sm="4" md="3" lg="3">
								<SideMenuComponent/>
							</Col>
							<Col sm="8" md="9" lg="9">
								<Card border="">
									<Card.Body>
										<Row className='centered-form'>
											<div style={{fontWeight: "bold",fontSize: "large",marginBottom:"10px",borderBottom:"2px solid #3998ac"}}>
												Menu upload
											</div>
											<Col className="nomobile"></Col>
											<Col xs="12" sm="12" md="5" lg="5">
												<Form onSubmit={this.onFileUpload}>
													<Form.Group className="mb-2">
														<Form.Label>Select Financial Year</Form.Label>
														<Select options={finyearOptions} name="finYear" id="finYear" onChange={this.onChangeFinyear}/>
													</Form.Group>
													<Form.Group className="mb-2">
														<Form.Label>Select Existing Menu</Form.Label>
														<Select options={existingMenuOption} name="menu" id="menu" onChange={this.onChangeMenu}/>
													</Form.Group>
													<Form.Group className="mb-2">
														<Form.Label>Title</Form.Label>
														<Form.Control type="text" placeholder=""  onChange={this.onChangeTitle} disabled={disabled}/>
													</Form.Group>
													<Form.Group className="mb-2">
														<Form.Label>Description</Form.Label>
														<Form.Control as="textarea" rows={2} onChange={this.onChangeDesc} disabled={disabled}/>
													</Form.Group>
													<Form.Group className="mb-2">
														<Form.Label>Select parent menu</Form.Label>
														<Select options={menuListOptions} name="parentMenu" id="parentMenu" onChange={this.onChangeParentMenu} disabled={disabled}/>
													</Form.Group>
													<Form.Group className="mb-2">
														<Form.Label>Select file to upload</Form.Label>
														<Form.Control type="file" size="sm" name="pdfFile" id="pdfFile" onChange={this.onFileChange}/>
													</Form.Group>
													<Form.Group className="mb-2 text-end">
														<Button type="reset" variant="warning mx-2">Reset</Button>									
														<Button type="submit" variant="primary">Save</Button>									
													</Form.Group>
												</Form>
											</Col>
											<Col className="nomobile col-3"></Col>
										</Row>
									</Card.Body>
								</Card>						
							</Col>
						</Row>
					</Container>
				</div>
				<FooterComponent/>
			</div>
		)

	}
} 
 
export default AddMenuComponent